export function EditIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_65_68)">
        <path
          d="M10.9217 1.4422L9.42868 0.0734063C9.32192 -0.0244688 9.13549 -0.0244688 9.02873 0.0734063L3.82944 4.84017C3.8159 4.85258 3.8159 4.87693 3.80288 4.90128C3.78934 4.9137 3.76278 4.92563 3.76278 4.94998L3.016 6.99101C2.9759 7.08889 3.016 7.18677 3.08266 7.25981C3.13578 7.30851 3.21597 7.33333 3.28263 7.33333C3.30919 7.33333 3.34929 7.33333 3.37585 7.32092L5.60208 6.63627C5.62864 6.62385 5.62864 6.61192 5.6552 6.5995C5.66874 6.58709 5.6953 6.58709 5.72185 6.57515L10.9075 1.82086C11.0284 1.71105 11.0284 1.54008 10.9217 1.4422Z"
          fill="#565656"
        />
        <path
          d="M10.6093 4.28672C10.4071 4.28672 10.2548 4.44849 10.2548 4.62669V9.81966L0.725398 9.81902V0.679319H6.12299C6.32526 0.679319 6.47748 0.517554 6.47748 0.339354C6.47748 0.161154 6.3088 -0.000610352 6.12299 -0.000610352L0.370844 2.15418e-05C0.168569 2.15418e-05 0.0163574 0.161786 0.0163574 0.339986V10.1754C0.0163574 10.3694 0.185032 10.5154 0.370844 10.5154H10.6264C10.8287 10.5154 10.9809 10.3536 10.9809 10.1754V4.62675C10.9809 4.43213 10.8123 4.28672 10.6093 4.28672Z"
          fill="#3D3D3D"
        />
      </g>
      <defs>
        <clipPath id="clip0_65_68">
          <rect width="11" height="11" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
